<div class="shell">
    <app-header (menuToggle)="toggleMobileNav()"></app-header>
    <div class="shell__body">
        <div class="shell__backdrop" [class.shell__backdrop--visible]="mobileNavOpen" (click)="closeMobileNav()"></div>
        <app-side-nav [(mobileOpen)]="mobileNavOpen"></app-side-nav>
        <main class="shell__content">
            <ng-container *ngIf="sessionExpired$ | async; else maybeSignUp">
                <app-session-expired-landing></app-session-expired-landing>
            </ng-container>
            <ng-template #maybeSignUp>
                <ng-container *ngIf="signUpRequired$ | async; else routedContent">
                    <app-unauthenticated-landing></app-unauthenticated-landing>
                </ng-container>
            </ng-template>
            <ng-template #routedContent>
                <router-outlet></router-outlet>
            </ng-template>
        </main>
    </div>
</div>
